/* eslint-disable import/no-cycle */
import React from 'react';
import { Divider, HStack, Stack } from '@chakra-ui/core';
import { useTranslation } from 'react-i18next';
import InputPreview from '../formInputs/InputPreview';
import FormLabelInput from '../formInputs/FormLabelInput';
import FormTextInput from '../formInputs/FormTextInput';
import { FormBuilderComponentProps } from '../types';

const EmailField = React.memo(
  ({ fieldId, isAdvanced, labelRightRenderer }: Omit<FormBuilderComponentProps, 'path'>) => {
    const { t } = useTranslation('hrFormTemplate');

    return (
      <Stack>
        <HStack justify="space-between">
          <FormLabelInput fieldId={fieldId} isAdvanced={isAdvanced} />
          <HStack flexShrink={0}>
            <Divider orientation="vertical" />
            {labelRightRenderer}
          </HStack>
        </HStack>
        <FormTextInput
          fieldId={fieldId}
          placeholder={t('formBuilder.editorPlaceholder.email')}
          isAdvanced={isAdvanced || false}
        />
        <InputPreview value="example@domain.com" fieldId={fieldId} />
      </Stack>
    );
  },
  (p, n) =>
    /* eslint-disable-next-line  */
    p.fieldId === n.fieldId && p.isAdvanced === n.isAdvanced && p.labelRightRenderer === n.labelRightRenderer,
);

EmailField.displayName = 'EmailField';
export default EmailField;
